import React, { useState } from "react";
import "../component/modalAddPatient.css";

import { createPortal } from "react-dom";

const ModalAddPatient = ({
  isShowModal,
  onCloseModal,
  onSubmitData,
  patientObject,
}) => {
  const [patientData, setPatientData] = useState(patientObject);

  const closeModal = () => {
    setPatientData({
      patient_id: "",
      patient_name: "",
      patient_birthday: null,
      patient_gender: "",
      patient_address: "",
      patient_phone_number: "",
    });
    onCloseModal();
  };

  const formatDate = (date, isAsValue) => {
    const options = {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      timeZone: "Asia/Jakarta",
    };

    const result = new Intl.DateTimeFormat("id-ID", options).format(date);
    if (isAsValue) {
      const [day, month, year] = result.split("/");
      return `${year}-${month}-${day}`;
    }
    return result;
  };

  const convertStringToDate = (dateString) => {
    var dateParts = dateString.split("/");
    var dateObject = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
    return dateObject;
  };

  return createPortal(
    isShowModal && (
      <div className="modal-patient-container">
        <div className="modal-patient-content">
          <header className="modal-patient-header">
            <h2 className="modal-patient-header-title">Tambah Pasien</h2>
            <button className="modal-header-close-button" onClick={closeModal}>
              &times;
            </button>
          </header>
          <main className="modal-patient-main">
            <div className="form-group-patient">
              <div className="input-title-label-container">
                <span className="input-title-label">Nama Pasien</span>
              </div>
              <div className="input-patient-field-container">
                <input
                  type="text"
                  value={
                    patientData.patient_name ? patientData.patient_name : ""
                  }
                  onChange={(e) =>
                    setPatientData({
                      ...patientData,
                      patient_name: e.target.value,
                    })
                  }
                  placeholder="Masukkan nama pasien"
                />
              </div>
              <div className="input-title-label-container">
                <span className="input-title-label">Tanggal Lahir Pasien</span>
              </div>
              <div className="input-patient-field-container">
                <input
                  type="date"
                  value={
                    patientData.patient_birthday
                      ? formatDate(
                          convertStringToDate(patientData.patient_birthday),
                          true
                        )
                      : formatDate(new Date(), true)
                  }
                  onChange={(e) => {
                    const selectedDate = new Date(e.target.value);
                    const formattedDate = formatDate(selectedDate, false);
                    setPatientData({
                      ...patientData,
                      patient_birthday: formattedDate,
                    });
                  }}
                  placeholder="Masukkan tanggal lahir pasien"
                />
              </div>
              <div className="input-title-label-container">
                <span className="input-title-label">Jenis Kelamin Pasien</span>
              </div>
              <div className="input-patient-field-container">
                <label>
                  <input
                    type="radio"
                    name="patient_gender"
                    value="L"
                    checked={patientData.patient_gender === "L"}
                    onChange={(e) =>
                      setPatientData({
                        ...patientData,
                        patient_gender: e.target.value,
                      })
                    }
                  />
                  L (Laki-laki)
                </label>
                <label>
                  <input
                    type="radio"
                    name="patient_gender"
                    value="P"
                    checked={patientData.patient_gender === "P"}
                    onChange={(e) =>
                      setPatientData({
                        ...patientData,
                        patient_gender: e.target.value,
                      })
                    }
                  />
                  P (Perempuan)
                </label>
              </div>
              <div className="input-title-label-container">
                <span className="input-title-label">Alamat Pasien</span>
              </div>
              <div className="input-patient-field-container">
                <input
                  type="text"
                  value={
                    patientData.patient_address
                      ? patientData.patient_address
                      : ""
                  }
                  onChange={(e) =>
                    setPatientData({
                      ...patientData,
                      patient_address: e.target.value,
                    })
                  }
                  placeholder="Masukkan alamat pasien"
                />
              </div>
              <div className="input-title-label-container">
                <span className="input-title-label">No Handphone Pasien</span>
              </div>
              <div className="input-patient-field-container">
                <input
                  type="text"
                  value={
                    patientData.patient_phone_number
                      ? patientData.patient_phone_number
                      : ""
                  }
                  onChange={(e) =>
                    setPatientData({
                      ...patientData,
                      patient_phone_number: e.target.value,
                    })
                  }
                  placeholder="Masukkan no handphone pasien"
                />
              </div>
            </div>
          </main>
          <footer className="modal-patient-footer">
            <button className="modal-close-button" onClick={closeModal}>
              Batal
            </button>
            <button
              className="modal-submit-button"
              onClick={() => {
                const isEditData = patientData.patient_id !== "";
                onSubmitData(patientData, isEditData);
                setPatientData({
                  patient_id: "",
                  patient_name: "",
                  patient_birthday: new Date(),
                  patient_gender: "",
                  patient_address: "",
                  patient_phone_number: "",
                });
              }}
            >
              Submit
            </button>
          </footer>
        </div>
      </div>
    ),
    document.getElementById("modal")
  );
};

export default ModalAddPatient;
